import axios from 'axios';
import { showSnackBar } from '../components/UI/HOC/SnackBar/store/actions';
import store from '../store/configureStore';
import { getCookie, setCookie, getQueryParams } from './utils';
import { flutterNativeCall } from './flutterNative';
let ip = window.location.origin;
declare let operatorapp: any;
declare let window: any;

if (window.location.host === 'localhost:3000') {
  ip = 'https://trucking-web.stage.wheelseye.in';
} else if (window.location.host === 'wheelseye.com') {
  ip = 'https://wheelseye.com';
} else {
  ip = window.location.origin;
}

const headers: any = {};

export const getUrlParameter = (name: any) => {
  if (!sessionStorage.getItem('x-app-version:')) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(window.location.search);
    let main = results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    sessionStorage.setItem('x-app-version:', main);
  }
};
if (!sessionStorage.getItem('x-app-version:')) {
  getUrlParameter('X-APP-NAME');
}
export const getUrlParameterVersionCode = (name: any) => {
  if (!sessionStorage.getItem('x-app-version-code')) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(window.location.search);
    let main = results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    sessionStorage.setItem('x-app-version-code', main);
  }
};

if (!sessionStorage.getItem('x-app-version-code')) {
  getUrlParameterVersionCode('X-APP-VERSION');
}

export const getUrlParameterPlatForm = (name: any) => {
  if (!sessionStorage.getItem('x-app-platform:')) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(window.location.search);
    let main = results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    sessionStorage.setItem('x-app-platform:', main);
  }
};
if (!sessionStorage.getItem('x-app-platform:')) {
  getUrlParameterPlatForm('X-APP-PLATFORM');
}

export const getUrlParameterXappName = (name: any) => {
  if (!sessionStorage.getItem('x-app-name:')) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(window.location.search);
    let main = results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    sessionStorage.setItem('x-app-name:', main);
  }
};

if (!sessionStorage.getItem('x-app-name:')) {
  getUrlParameterXappName('X-APP-NAME');
}

export const getToken = () => {
  const params = getQueryParams();
  const accessToken = params.token;
  return accessToken || localStorage.getItem('accessToken') || '';
};

export const getSessionId = () => {
  // const params = getQueryParams();
  // const sessionId = params['session-id'];
  return sessionStorage.getItem('session-id') || '';
};

export const getUtmSource = () => {
  const params = getQueryParams();
  const utm_source = params['utm_source'] || params['source'];
  return utm_source || '';
};

// setTimeout(getStateId, 1000);

export const getAppVersion = () => {
  return sessionStorage.getItem('x-app-version:') || '';
};

export const getAppPlatForm = () => {
  return sessionStorage.getItem('x-app-platform:') || '';
};

export const getUserCode = () => {
  const params = getQueryParams();
  const userCode = params['USER-CODE'];
  if (!!userCode && userCode !== localStorage.getItem('userCode')) {
    localStorage.setItem('userCode', userCode);
  }
  return userCode || localStorage.getItem('userCode') || '';
};

export const getAppId = () => {
  const params = getQueryParams();
  const appId = params['X-APP-ID'];
  if (!!appId && appId !== localStorage.getItem('appId')) {
    localStorage.setItem('appId', appId);
  }
  return appId || localStorage.getItem('appId') || '';
};

export const getOperatorId = () => {
  const params = getQueryParams();
  const operatorId = params['OP-ID'];
  if (!!operatorId && operatorId !== localStorage.getItem('operatorId')) {
    localStorage.setItem('operatorId', operatorId);
  }
  return operatorId || localStorage.getItem('operatorId') || '';
};

export const getLocale = () => {
  // const params = getQueryParams();
  // const locale = params.locale ? params.locale : 'hi';
  return 'hi';
};

if (!sessionStorage.getItem('session-id')) {
  let r = (Math.random() + 1).toString(36).substring(2);

  sessionStorage.setItem('session-id', r);
}
export const getLocaleHeader = () => {
  const params = getQueryParams();
  // if (!!params) {
  //   const locale = params.locale;
  //   return locale || localStorage.getItem('locale') || 'hi';
  // }
  // return '';

  if (!!params) {
    const defaultLocale = params.locale;
    return localStorage.getItem('locale') || defaultLocale || 'hi';
  }
  return 'hi';
};

headers.token = getToken();
headers.locale = getLocaleHeader();

headers['session-id'] = getSessionId();

if (!getUtmSource()) {
  headers['utm-source'] = 'DEMAND_PAGE';
} else {
  headers['utm-source'] = getUtmSource();
}
headers['X-APP-VERSION'] = getAppVersion();
headers['X-APP-PLATFORM'] = getAppPlatForm();

export const logout = () => {
  if (getCookie('googleAuth')) {
    setCookie('email', ';expires=Thu, 01 Jan 1970 00:00:01 GMT;', 8);
    setCookie('googleAuth', ';expires=Thu, 01 Jan 1970 00:00:01 GMT;', 8);
  } else if (localStorage.getItem('accessToken')) {
    localStorage.clear();
  }
  window.location.href = '/operatorlogin';
};
/**Dev key */
// export const MAP_KEY = 'AIzaSyAyWL0a-gTuCOVfpQSKAVFyL7MKF1cMZeQ';
/**Prod key */
export const MAP_KEY = 'AIzaSyDyFixz6HrYe7HXqdyHCjoHHMbS6CH5G9M';

export const rootPath = ip + '';

axios.defaults.withCredentials = true;

export const appendTimeStampInUrlQueryParams = (url: string) => {
  return url + (url.split('?')[1] ? '&' : '?') + `t=${new Date().getTime()}`;
};

const addTimeStampQueryParam = ({ url, ...restConfig }: any) => {
  return {
    ...restConfig,
    url: appendTimeStampInUrlQueryParams(url),
  };
};

const localUrl = 'http://localhost:8080';

export const localInstance = axios.create({
  baseURL: localUrl,
  headers: {
    user: JSON.stringify({ code: 'WE10160' }),
    // token: getToken(),
    // 'utm-source': !getUtmSource() ? 'DEMAND_PAGE' : getUtmSource(),
    // 'x-app-version': getAppVersion(),
    // 'x-app-platform': getAppPlatForm(),
    // locale: getLocale(),
  },
});

const api = axios.create({
  baseURL: rootPath,
  headers: headers,
});

export const api2 = axios.create({
  baseURL: rootPath,
  headers: headers,
});
export const exceptionApi = axios.create({
  baseURL: rootPath,
  headers: headers,
});

// Add a response interceptor
api.interceptors.response.use(
  function (response: any) {
    return response;
  },
  function (error: any) {
    if (error && error.response) {
      if (error.response?.status === 401) {
        logout();
      } else if (error.response?.status === 409) {
        window.location.reload();
      }
    }
    // if (error && error.response && error.response.status === 400) {
    //   store.dispatch(showSnackBar({ variant: 'error', message: error.response.data.message }));
    // }
    return Promise.reject(error);
  },
);
exceptionApi.interceptors.request.use(addTimeStampQueryParam, function (error) {
  return Promise.reject(error);
});
api.interceptors.request.use(addTimeStampQueryParam, function (error) {
  return Promise.reject(error);
});
api2.interceptors.response.use(
  function (response: any) {
    return response;
  },
  function (error: any) {
    if (error && error.response) {
      if (error.response.status === 401) {
        logout();
      } else if (error.response.status === 400) {
        store.dispatch(showSnackBar({ variant: 'error', message: error.response.data.message }));
      } else if (error.response.status === 409) {
        window.location.reload();
      }
    }
    return Promise.reject(error);
  },
);
api2.interceptors.request.use(addTimeStampQueryParam, function (error) {
  return Promise.reject(error);
});
export function setToken(token: string) {
  api.defaults.headers.common['token'] = token;
}

export function setCookieInheaders(token: string) {
  api.defaults.headers.common['token'] = token;
}

export const handleBackApp = (canGoBack: boolean, goBack: () => void) => {
  void handleBackAppNative(canGoBack, goBack);
};

const handleBackAppNative = async (canGoBack: boolean, goBack: () => void) => {
  if (await flutterNativeCall('onGoBack', {})) {
    return;
  }

  let xAppPlatform = typeof sessionStorage === 'undefined' ? '' : sessionStorage['x-app-platform:'];
  const xAppVersion = typeof sessionStorage === 'undefined' ? '' : sessionStorage['x-app-version:'];
  const isCorrectVersion = versionCheckFunction(xAppVersion, '18.2.0');
  try {
    if (xAppPlatform === 'android') {
      if (isCorrectVersion) {
        operatorapp.nativeAction('onGoBack', {});
      } else {
        if (canGoBack) {
          goBack();
        } else if (operatorapp && typeof operatorapp !== 'undefined' && operatorapp !== null) {
          operatorapp.nativeAction('exit', {});
        } else {
          alert('Not viewing in webview');
        }
      }
    } else if (xAppPlatform === 'ios_operator') {
      if (window.webkit !== undefined) {
        const backProps = {
          injectType: 'BACK_BUTTON_CLICKED',
        };
        if (window.webkit.messageHandlers.operatorapp !== undefined) {
          window.webkit.messageHandlers.operatorapp.postMessage(backProps);
        }
      }
    }
  } catch (error) {
    alert(error);
  }
};

export const S3Instance = axios.create({
  baseURL: ip,
  withCredentials: false,
  headers: {
    token: getToken(),
    'x-app-version': ' ',
    'x-app-platform': ' ',
  },
});

export const versionCheckFunction = (curentVersion: string, comparableVerson: string) => {
  let firstArray = curentVersion?.split('.');
  let secondArray = comparableVerson?.split('.');

  let numOneJoin = firstArray.join('');
  let numOneWithoutComma = numOneJoin.split(',').join('');
  let numOneCurentVersion = Number(numOneWithoutComma);

  let numTwoJoin = secondArray.join('');
  let numTwoWithoutComma = numTwoJoin.split(',').join('');
  let numTwoCurentVersion = Number(numTwoWithoutComma);

  if (numOneCurentVersion >= numTwoCurentVersion) {
    return true;
  } else {
    return false;
  }
};

// export const checkVer = versionCheckFunction(xAppVersion, '12.8.1');

export default api;
